module.exports = __webpack_public_path__ + "assets/page-big.e9be158e.svg";